<template>
  <el-container>
    <el-header height="500px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-menu background-color="transparent" text-color="#fff" active-text-color="#fff" default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">首页</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="10">

        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <img class="logo-3" src="@/assets/logo-3.png" alt="">
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :offset="8" :span="8">
          <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select">
            <el-button class="search-button" slot="append" icon="el-icon-search" @click="toSearch">&nbsp;搜&nbsp;&nbsp;&nbsp;索&nbsp;</el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <div class="banner-hd" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: rgb(248, 248, 248); margin-bottom: 49px; -webkit-box-orient: vertical; -webkit-box-direction: normal; display: flex; flex-direction: column; -webkit-box-pack: center; justify-content: center; -webkit-box-align: center; align-items: center; font-family: &quot;Microsoft YaHei&quot;, arial, simsun, sans-serif; font-size: medium;">
        <div style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; margin-bottom: 30px;">
          <span class="banner-title" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; margin-right: 20px; float: left; display: inline-block; font-size: 40px; font-weight: 700; line-height: 41px; color: rgb(51, 51, 51);">
            打造电商流量生态标杆 开放共赢赋能营销生态
          </span>
        </div>
        <p style="box-sizing: inherit; margin-bottom: 10px; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; color: rgb(0, 0, 0); font-size: 14px;">
          整合全流量资源 高效精准扶持推广
        </p>
        <p style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; color: rgb(0, 0, 0); font-size: 14px;">
          推广矩阵 创造多元化的流量价值体系
        </p>
      </div>
      <ul class="banner-cnt" style="padding: 0 40px;box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: rgb(248, 248, 248); list-style: none; display: flex; -webkit-box-pack: justify; justify-content: space-between; font-family: &quot;Microsoft YaHei&quot;, arial, simsun, sans-serif; font-size: medium;"><li data-index="0" class="list-item" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: rgb(255, 255, 255); margin-left: 0px; padding-right: 16px; padding-left: 16px; box-shadow: rgba(145, 0, 0, 0.1) 0px 1px 10px 0px; float: left; -webkit-box-orient: vertical; -webkit-box-direction: normal; display: flex; width: 230px; min-width: 230px; height: 235px; flex-direction: column; -webkit-box-pack: center; justify-content: center; -webkit-box-align: center; align-items: center; border-radius: 10px;"><div class="list-icon list-item0" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: url(&quot;https://img14.360buyimg.com/imagetools/jfs/t1/149555/35/18334/23376/5fd8b675Eb6c4241a/06e09108657badd0.png&quot;) -67px 0px transparent; margin: 10px auto 19px; width: 50px; height: 50px;"></div><h2 style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; height: 24px; line-height: 24px; font-family: MicrosoftYaHei-Bold; font-size: 18px; color: rgb(51, 51, 51);">社交导购类场景</h2><p style="box-sizing: inherit; margin: 17px 15px; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; line-height: 1.5; font-size: 14px; width: 170px; color: rgb(102, 102, 102);">如个人社交推客、代理APP、综合+垂直导购APP</p></li><li data-index="1" class="list-item" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: rgb(255, 255, 255); margin-left: 0px; padding-right: 16px; padding-left: 16px; box-shadow: rgba(145, 0, 0, 0.1) 0px 1px 10px 0px; float: left; -webkit-box-orient: vertical; -webkit-box-direction: normal; display: flex; width: 230px; min-width: 230px; height: 235px; flex-direction: column; -webkit-box-pack: center; justify-content: center; -webkit-box-align: center; align-items: center; border-radius: 10px;"><div class="list-icon list-item1" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: url(&quot;https://img14.360buyimg.com/imagetools/jfs/t1/149555/35/18334/23376/5fd8b675Eb6c4241a/06e09108657badd0.png&quot;) -68px -57px transparent; margin: 10px auto 19px; width: 50px; height: 50px;"></div><h2 style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; height: 24px; line-height: 24px; font-family: MicrosoftYaHei-Bold; font-size: 18px; color: rgb(51, 51, 51);">达人网红自媒体</h2><p style="box-sizing: inherit; margin: 17px 15px; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; line-height: 1.5; font-size: 14px; width: 170px; color: rgb(102, 102, 102);">如微博大V、直播&amp;短视频红人、公众号等</p></li><li data-index="2" class="list-item" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: rgb(255, 255, 255); margin-left: 0px; padding-right: 16px; padding-left: 16px; box-shadow: rgba(145, 0, 0, 0.1) 0px 1px 10px 0px; float: left; -webkit-box-orient: vertical; -webkit-box-direction: normal; display: flex; width: 230px; min-width: 230px; height: 235px; flex-direction: column; -webkit-box-pack: center; justify-content: center; -webkit-box-align: center; align-items: center; border-radius: 10px;"><div class="list-icon list-item2" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: url(&quot;https://img14.360buyimg.com/imagetools/jfs/t1/149555/35/18334/23376/5fd8b675Eb6c4241a/06e09108657badd0.png&quot;) -73px -111px transparent; margin: 10px auto 19px; width: 50px; height: 50px;"></div><h2 style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; height: 24px; line-height: 24px; font-family: MicrosoftYaHei-Bold; font-size: 18px; color: rgb(51, 51, 51);">资讯内容类媒体</h2><p style="box-sizing: inherit; margin: 17px 15px; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; line-height: 1.5; font-size: 14px; width: 170px; color: rgb(102, 102, 102);">如门户、新闻资讯、内容平台等</p></li><li data-index="3" class="list-item" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: rgb(255, 255, 255); margin-left: 0px; padding-right: 16px; padding-left: 16px; box-shadow: rgba(145, 0, 0, 0.1) 0px 1px 10px 0px; float: left; -webkit-box-orient: vertical; -webkit-box-direction: normal; display: flex; width: 230px; min-width: 230px; height: 235px; flex-direction: column; -webkit-box-pack: center; justify-content: center; -webkit-box-align: center; align-items: center; border-radius: 10px;"><div class="list-icon list-item3" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: url(&quot;https://img14.360buyimg.com/imagetools/jfs/t1/149555/35/18334/23376/5fd8b675Eb6c4241a/06e09108657badd0.png&quot;) -74px -169px transparent; margin: 10px auto 19px; width: 50px; height: 50px;"></div><h2 style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; height: 24px; line-height: 24px; font-family: MicrosoftYaHei-Bold; font-size: 18px; color: rgb(51, 51, 51);">入口工具类媒体</h2><p style="box-sizing: inherit; margin: 17px 15px; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; line-height: 1.5; font-size: 14px; width: 170px; color: rgb(102, 102, 102);">如基础工具、入口、手机厂商、OTT等</p></li><li data-index="4" class="list-item" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: rgb(255, 255, 255); margin-left: 0px; padding-right: 16px; padding-left: 16px; box-shadow: rgba(145, 0, 0, 0.1) 0px 1px 10px 0px; float: left; -webkit-box-orient: vertical; -webkit-box-direction: normal; display: flex; width: 230px; min-width: 230px; height: 235px; flex-direction: column; -webkit-box-pack: center; justify-content: center; -webkit-box-align: center; align-items: center; border-radius: 10px;"><div class="list-icon list-item4" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: url(&quot;https://img14.360buyimg.com/imagetools/jfs/t1/149555/35/18334/23376/5fd8b675Eb6c4241a/06e09108657badd0.png&quot;) -76px -225px transparent; margin: 10px auto 19px; width: 50px; height: 50px;"></div><h2 style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; height: 24px; line-height: 24px; font-family: MicrosoftYaHei-Bold; font-size: 18px; color: rgb(51, 51, 51);">线下门店场景</h2><p style="box-sizing: inherit; margin: 17px 15px; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; line-height: 1.5; font-size: 14px; width: 170px; color: rgb(102, 102, 102);">如3C门店、快递站点、小店主、社区团购、校园推客</p></li></ul>
      <div class="joinus" style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: url(&quot;https://img10.360buyimg.com/imagetools/jfs/t1/139750/22/18884/106707/5fdc6846E0d4128a4/e94c202d1b14e6a5.png&quot;) center center / cover transparent; display: flex; -webkit-box-pack: center; justify-content: center; -webkit-box-align: center; align-items: center; height: 120px; width: 100%; overflow: hidden;">
        <span style="box-sizing: inherit; border: 0px; outline: 0px; vertical-align: baseline; background: transparent; color: rgb(255, 255, 255); font-size: 28px;">
          超过百万推客已步入智能选品时代，赶快加入我们吧！
        </span>
      </div>
    </el-main>
    <el-footer height="200px">
      <el-row :gutter="20" style="text-align: left;margin-top: 50px;margin-bottom: 10px;">
        <el-col :offset="3" :span="9">
          快捷入口
        </el-col>
        <el-col :span="9">
          联系我们
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom: 10px;">
        <el-col :offset="3" :span="9">
          <el-row style="text-align: left;margin-left: 10px;margin-bottom: 10px;">
            <el-col :span="4">
              <a style="font-size: 12px;color:rgb(153, 153, 153) !important;" href="https://j-yy.cn/task/2">运营三要素</a>
            </el-col>
            <el-col :span="4">
              <a style="font-size: 12px;color:rgb(153, 153, 153) !important;"  href="https://j-yy.cn/task/6">运营常用文案</a>
            </el-col>
            <el-col :span="4">
              <a style="font-size: 12px;color:rgb(153, 153, 153) !important;"  href="https://j-yy.cn/task/5">运营技巧</a>
            </el-col>
            <el-col :span="4">
              <a style="font-size: 12px;color:rgb(153, 153, 153) !important;"  href="https://j-yy.cn/task/3">快速扩大群</a>
            </el-col>
          </el-row>
          <el-row style="margin-left: 10px;text-align: left;">
            <el-col :span="4">
              <a style="font-size: 12px;color:rgb(153, 153, 153) !important;"  href="https://j-yy.cn/task/4">如何发品</a>
            </el-col>
            <el-col :span="4">
              <a style="font-size: 12px;color:rgb(153, 153, 153) !important;"  href="https://j-yy.cn/task/8">如何转链</a>
            </el-col>
            <el-col :span="4">
              <a style="font-size: 12px;color:rgb(153, 153, 153) !important;"  href="https://j-yy.cn/task/18">其它</a>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9">
          <el-row style="margin-left: 10px;text-align: left;margin-bottom: 10px;">
            <el-col :span="24">
              <span style="font-size: 12px;color:rgb(153, 153, 153) !important;">
                电话：15038828476
              </span>
            </el-col>
          </el-row>
          <el-row style="margin-left: 10px;text-align: left;">
            <el-col :span="24">
              <span style="font-size: 12px;color:rgb(153, 153, 153) !important;">
                邮箱：621171@qq.com
              </span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :offset="3" :span="16" style="padding-top: 10px;border-top: 1px solid #494c4f;">
          <a style="font-size: 14px; color: #fff;" href="https://beian.miit.gov.cn/">{{ icpnumber }}</a>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      keyword: '',
      icpnumber: '津ICP备20004248号-1'
    }
  },
  /**
   * 在组件创建之后被调用
   */
  created () {
    var host = window.location.host
    if (host.indexOf('j-yy.cn') >= 0) {
      this.icpnumber = '津ICP备20004248号-1'
    } else if (host.indexOf('j-xd.cn') >= 0) {
      this.icpnumber = '津ICP备20004248号-2'
    } else if (host.indexOf('j-dl.cn') >= 0) {
      this.icpnumber = '津ICP备20004248号-3'
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    toSearch () {
      window.location.href = 'http://jd-inbuy.com/search?k=' + this.keyword + '&o=0&h=0&p=0&sn=all&s=0'
      // this.$router.push({
      //   path: '/search'
      // })
    }
  }
}
</script>

<style>
.search-button {
  color: #fff !important;
  background: linear-gradient(to right, #e42944, #e7673a) !important;
}
.logo-3 {
  width: 150px;
  margin: 150px 0 20px 0;
}
.el-menu .el-menu-item:hover {
  background: transparent !important;
}
.el-menu .el-menu-item.is-active {
  font-size: 16px;
  font-weight: bolder;
}
.el-header {
  background: url(~@/assets/background.jpg) 0% 40% no-repeat;
}
.el-footer {
  background-color: #34383b;
  text-align: center;
  font-size: 16px;
  color: #fff;
}
.el-footer a {
  text-decoration-line: none;
  color: #fff;
}
.el-container .el-main {
  padding: 20px 0px 0px 0px !important;
  color: #333;
  background: rgb(248, 248, 248);
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue